import React from 'react';
import './CustomVolumeSlider.css';

// Slider component used for volume / brightness / threshold settings.
// The fill gradient and thumb colour are driven by the brand orange so
// every slider on the dashboard speaks the same visual language.

const CustomSlider = ({
    label = 'Volume',
    value,
    onChange,
    min = 0,
    max = 100,
}) => {
    // Translate value→percentage for the linear-gradient fill so it works
    // for any min/max range, not just 0-100.
    const pct = ((value - min) / (max - min)) * 100;

    return (
        <div className="w-full mt-4">
            <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">
                {label} ({value}%)
            </label>
            <input
                type="range"
                min={min}
                max={max}
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
                className="custom-slider w-full h-2 rounded-lg appearance-none cursor-pointer"
                style={{
                    background: `linear-gradient(to right, #ff7a1f 0%, #ff7a1f ${pct}%, #2a2a2a ${pct}%, #2a2a2a 100%)`,
                }}
            />
        </div>
    );
};

export default CustomSlider;
